<loading-bar #loader style="position: absolute; width: 100%; z-index: 99999; top: 0px;"></loading-bar>
<router-outlet></router-outlet>
